import { ApplicationRoutePaths } from "@shared-core/routes/application-route-paths";

export abstract class QuotationExpirationSettingsRoutePaths extends ApplicationRoutePaths {
  static override readonly ROOT = "quotation-expiration-settings";
}
